import { atom, useRecoilValue } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

const setUpFlowDataAtom = atom({
  key: RecoilAtomKey.setUpFlowDataKey,
  default: {
    title: '',
    patterns: ['ecommerce'],
    tags: [],
    is_published: false,
    is_deleted: false,
    is_default: false,
    waba_id: '',
    phone_number_id: '',
    company_id: '',
    organisation_name: '',
    leads_form_name: '',
    app_name: '',
    campaign_id: '',
    campaign_name: '',
    lead_form_id: '',
    template_name: '',
    template_id: '',
    selectedCampaign: null,
    selectedForm: null,
    selectedOrganisation: null,
    selectedPhoneNumber: null,
    selectedTemplate: null,
    flowtype: 'ecommerce',
    _id: '',
  },
});
const setUpFlowNodeEdgeAtom = atom({
  key: RecoilAtomKey.setUpFlowNodeEdgeKey,
  default: {},
});

// Product List Atoms
const productListObjAtom = atom({
  key: RecoilAtomKey.productListObjKey,
  default: {},
});

const productFiltersAtom = atom({
  key: RecoilAtomKey.productFiltersKey,
  default: {
    search: '',
    page: 0,
    sortOrder: 'desc',
    sortField: 'name',
    category: '',
    bot_number: '',
    catalog_id: '',
  },
});

const selectedProductAtom = atom({
  key: RecoilAtomKey.selectedProductKey,
  default: {},
});

// Order Atoms
const selectedOrderAtom = atom({
  key: RecoilAtomKey.selectedOrderKey,
  default: {},
});

const orderListObjAtom = atom({
  key: RecoilAtomKey.orderListObjKey,
  default: {},
});
const orderFiltersAtom = atom({
  key: RecoilAtomKey.orderFiltersKey,
  default: {
    search: '',
    page: 0,
    sortOrder: '',
    sortField: '',
    category: '',
    order_status: '',
    payment_status: '',
    organisation: '',
    organisationObj: null,
    botNumber: '',
    channelObj: null,
    limit: 10,
  },
});

const orderStatusAtom = atom({
  key: RecoilAtomKey.orderStatusKey,
  default: [],
});

const paymentStatusListAtom = atom({
  key: RecoilAtomKey.paymentStatusListKey,
  default: [],
});
export {
  setUpFlowDataAtom,
  setUpFlowNodeEdgeAtom,
  productListObjAtom,
  productFiltersAtom,
  selectedOrderAtom,
  orderListObjAtom,
  orderFiltersAtom,
  selectedProductAtom,
  orderStatusAtom,
  paymentStatusListAtom,
};
